/*
 * Public API Surface of Info List Item
 */

export * from './info-list-item.component';
export * from './info-list-item.module';
